'use client';

import { usePathname, useSearchParams } from 'next/navigation';
import { useEffect } from 'react';
import { usePreservedCallback } from '@bgzt/hooks';

type Props = {
  /** path가 바뀌었을 때 */
  onPathChange?: ({
    pathname,
    searchParams,
  }: {
    pathname: ReturnType<typeof usePathname>;
    searchParams: ReturnType<typeof useSearchParams>;
  }) => void;
};

export const NavigationEvents = ({ onPathChange }: Props) => {
  const pathname = usePathname();
  const searchParams = useSearchParams();

  const stableOnPathChange = usePreservedCallback(onPathChange);

  useEffect(() => {
    stableOnPathChange?.({ pathname, searchParams });
  }, [pathname, searchParams, stableOnPathChange]);

  return null;
};
